import { useState } from "react";
import type { FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Shell } from "../components/Shell";
import { useAuth } from "../lib/auth-context";
import { auth as authApi, ApiError } from "../lib/api";

export function ChangePasswordPage() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    if (next.length < 12) {
      setError("La nueva contraseña debe tener al menos 12 caracteres.");
      return;
    }
    if (next !== confirm) {
      setError("Las contraseñas nuevas no coinciden.");
      return;
    }
    if (next === current) {
      setError("La nueva contraseña debe ser distinta a la actual.");
      return;
    }
    setSubmitting(true);
    try {
      await authApi.changePassword(current, next);
      await refresh();
      navigate("/", { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setError("Contraseña actual incorrecta.");
      } else if (err instanceof ApiError && err.status === 400) {
        setError(typeof err.detail === "string" ? err.detail : "Solicitud inválida.");
      } else {
        setError("No se pudo cambiar la contraseña.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Shell>
      <section className="page">
        <div className="card card-narrow">
          <div className="card-inner">
            <div className="eyebrow">Acceso · primera entrada</div>
            <h1 style={{ fontSize: 28 }}>Cambia tu contraseña</h1>
            <p className="lede">
              {user?.email
                ? `Por seguridad, ${user.email} debe definir una contraseña personal antes de continuar.`
                : "Por seguridad, debes definir una contraseña personal antes de continuar."}
            </p>

            {error && <div className="alert err">{error}</div>}

            <form onSubmit={onSubmit} noValidate>
              <div className="form-row">
                <label className="label" htmlFor="current">
                  Contraseña actual
                </label>
                <input
                  id="current"
                  className="input"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={current}
                  onChange={(e) => setCurrent(e.target.value)}
                  autoFocus
                />
              </div>

              <div className="form-row">
                <label className="label" htmlFor="next">
                  Nueva contraseña
                </label>
                <input
                  id="next"
                  className="input"
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={12}
                  value={next}
                  onChange={(e) => setNext(e.target.value)}
                />
                <p className="helper">Mínimo 12 caracteres.</p>
              </div>

              <div className="form-row">
                <label className="label" htmlFor="confirm">
                  Confirmar nueva contraseña
                </label>
                <input
                  id="confirm"
                  className="input"
                  type="password"
                  autoComplete="new-password"
                  required
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                />
              </div>

              <button
                className="cta"
                type="submit"
                disabled={submitting || !current || !next || !confirm}
              >
                <span className="cta-inner">
                  {submitting && <span className="spinner" aria-hidden />}
                  {submitting ? "Guardando…" : "Guardar y continuar"}
                </span>
              </button>
            </form>
          </div>
        </div>
      </section>
    </Shell>
  );
}
